"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merchantExtractor = void 0;
var merchantExtractor = function (response) { return response.merchant; };
exports.merchantExtractor = merchantExtractor;
//# sourceMappingURL=Merchant.consts.js.map